const POPULAR_COUNTRY_CODES = ['US', 'CA', 'DE', 'NL', 'ES', 'AU', 'IN', 'IT', 'FR'];

interface Args {
  countries: { name: string; callingCode: string; countryCode: string }[];
}

function useSortAndFormatCountryPhoneNumberCodes({ countries }: Args) {
  const popularCountries = countries
    .filter(({ countryCode }) => POPULAR_COUNTRY_CODES.includes(countryCode))
    .sort((a, b) => a.name === 'United States' ? -1 : a.name.localeCompare(b.name))
    .map(({ name, callingCode, countryCode }) => ({
      label: `${name} +${callingCode}`,
      value: `${callingCode}_${name}`,
    }));

  const otherCountries = countries
    .filter(({ countryCode }) => !POPULAR_COUNTRY_CODES.includes(countryCode))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(({ name, callingCode, countryCode }) => ({
      label: `${name} +${callingCode}`,
      value: `${callingCode}_${name}`,
    }));

  return {
    popularCountries,
    otherCountries
  };
}

export default useSortAndFormatCountryPhoneNumberCodes;
